<template>
  <div class="container">
    <el-row :gutter="10" class="button-box">
      <el-button type="text" @click="selectAll" size="mini">全选</el-button>
      <el-button type="text" @click="cancelALL" size="mini">取消</el-button>
      &nbsp;
      <slot name="seach-box"/>
      &nbsp;
      <el-badge class="mark" :value="selectedRowList.length">
        <el-tag type="success" size="mini">已选</el-tag>
      </el-badge>
      &nbsp;
      <el-badge class="mark" :value="tableData.length">
        <el-tag type="primary" size="mini">全部</el-tag>
      </el-badge>
    </el-row>
    <vueVirtualTable
      :config="tableConfig"
      :data="tableData"
      :minWidth = 600
    >
      <template slot-scope="scope" slot="select_slot">
        <el-button type="text" v-if="isSelected(scope.row) === -1" size="mini" @click="handleSelect(scope.row)">选择
        </el-button>
        <el-button type="text" v-else size="mini" class="danger-text" @click="cancelSelect(scope.row)">取消</el-button>
      </template>
       <template slot-scope="scope" slot="event_slot">
          <el-button
            type="text"
            size="mini"
            @click="usePrimaryModule(scope.row)"
          >使用通用模块</el-button>
        </template>
    </vueVirtualTable>
  </div>
</template>
<script>
import vueVirtualTable from 'vue-virtual-table';
import {apiChangeCustomModule} from '@/api';

// import lodash from 'lodash';
export default {
  name: 'zxVvTable',
  components: {
    vueVirtualTable
  },
  data () {
    return {
      searchText: '',
      defaultConfig: [
        { prop: "_action", name: "选择", actionName: "select_slot", width: 50 }
      ],
      selectedRowList: this.value,
      tableData: this.data
    };
  },
  props: {
    moduleType: {
      type: Number
    },
    value: {
      type: Array,
      default () {
        return [];
      }
    },
    config: {
      type: Array,
      default () {
        return [];
      }
    },
    data: {
      type: Array,
      default () {
        return [];
      }
    },
    valueKey: {
      type: String,
      default: 'id'
    }
  },
  mounted () {

  },
  methods: {
    async usePrimaryModule(row) {
      const { machine_uuid } = row;
      try {
       await apiChangeCustomModule(machine_uuid, this.moduleType);
       const idx = this.$_.findIndex(this.tableData, (a) => machine_uuid === a.machine_uuid);
       this.tableData.splice(idx, 1);
        this.$message.success('设置成功');
        // this.tableData.splice()
      } catch (e) {
        this.$message.success('设置失败' + e.message);
      }
    },
    selectAll () {
      this.selectedRowList = this.$_.concat(
        this.selectedRowList,
        this.tableData
      );
      this.selectedRowList = this.$_.uniqBy(this.selectedRowList, this.valueKey);
    },
    cancelALL () {
      this.selectedRowList = [];
    },
    handleSelect (row) {
      if (this.isSelected(row) === -1) {
        this.selectedRowList.push(row);
      } else {
        this.$message.error('此项目已选');
      }
    },
    cancelSelect (row) {
      const idx = this.isSelected(row);
      if (idx !== -1) {
        this.selectedRowList.splice(idx, 1);
      }
    }
  },
  computed: {
    tableConfig () {
      return [...this.defaultConfig, ...this.config];
    },
    _key () {
      return this.valueKey;
    },
    isSelected () {
     return (row) => {
       const key = this.valueKey;
         if (row.hasOwnProperty(key)) {
           let idx = this.$_.findIndex(this.selectedRowList, a => a[key] === row[key]);
           return idx;
         }
         return -1;
     };
    }
  },
  watch: {
    selectedRowList: {
      handler (val) {
        this.$emit('input', val);
      },
      deep: true
    },
    value: {
      handler (val) {
        this.selectedRowList = val;
      },
      deep: true
    },
    data: {
      handler (val) {
        this.tableData = val;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    .button-box {
      text-align: left;
      padding: 5px;
    }
    .search-box {
      display: inline-block;
      width: 200px;
      margin-left: 5px;
    }
  }

</style>
